import { useEffect } from 'react'

import cn from 'clsx'

import { useAppDispatch, useAppSelector } from '@App/hooks'
import { getCountriesAsync } from '@App/redux/slices/config/CountriesSlice'
import { Flag } from '@App/static/icons/Flags'
import { PlanetIcon } from '@App/static/icons/WalletPageIcons'
import { Checkbox } from '@App/ui/crypto_exchange/desktop/components/controls/Checkbox'

import s from './styles.module.scss'
import {asyncGetAvailableCalendarCountries} from "@Redux/slices/calendar/slice";

export const RegionFilter = ({ value, setFilter }: { value: string[]; setFilter: (val: string) => void }) => {
  const dispatch = useAppDispatch()
  useEffect(() => {
    dispatch(asyncGetAvailableCalendarCountries())
  }, [dispatch])
  const countries = useAppSelector((state) => state.calendarEvents.countries)

  return (
    <div className={s.container}>
      <div className={s.title}>Region</div>
      <ul className={s.options}>
        <li key={'all-regions'} className={s.option}>
          <PlanetIcon className={cn(s.icon, s.planet)} /> <span className={s.name}>All</span>
          <Checkbox name={'all-regions'} checked={value.some((v) => v === 'all')} onClick={() => setFilter('all')} />
        </li>
        {countries.map((country) => (
          <li key={country.key} className={s.option}>
            <Flag code={country.key} className={s.icon} /> <span className={s.name}>{country.name}</span>
            <Checkbox
              name={country.key}
              checked={value.some((v) => v === country.key)}
              onClick={() => setFilter(country.key)}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}
